<!-- <ul class="timeline">
    <li *ngFor="let tl of timelineItems" class="timeline-item bg-white rounded ml-3 p-4">
        <div  class="timeline-icon">
            <i class="fa fa-trash"></i>
        </div>

        <h6 class="mb-0">{{tl.title}}</h6>
        <span *ngIf="tl.date" class="small text-gray"><i class="fa fa-clock-o"></i></span>
        <p class="text-small mt-2 font-weight-light">{{tl.text}}</p>
    </li>
</ul>
   -->

   <div class="timeline" *ngIf="timelineItems.length > 0">
    <h3 *ngIf="title">{{title}}</h3>
    <label *ngIf="subTitle">{{subTitle}}</label>

    <div class="box">
        <div class="container">

            <div class="lines">
                <div *ngFor="let tl of timelineItems;let i = index">
                    <div class="dot"></div>
                    <div *ngIf="i < (timelineItems.length - 1)" class="line"></div>
                </div>
            </div>

            <div class="cards">
                <div class="card" *ngFor="let tl of timelineItems">
                    <div *ngIf="tl.icon" class="timeline-icon">
                        <i [class]="tl.icon"></i>
                    </div>
                    <h4>{{tl.title}}</h4>
                    <p [innerHTML]="">{{tl.text}}</p>
                </div>
            </div>

        </div>


    </div>
</div>

<div *ngIf="!timelineItems || timelineItems.length == 0" style="padding: 15px; background: #bee5eb;">
    <table style="margin: 0 auto;">
      <tbody>
        <tr>
          <td>
            <b>No hay datos por mostrar.</b>
          </td>
        </tr>
      </tbody>
    </table>
  </div>